import React, { ChangeEvent, useCallback, useEffect, useState } from 'react'
import Select from 'react-select';
import { TruncatedText } from '../../../common/CustomTooltip'
import { IInserviceWorkShop } from '../../../../interface/Inservice';
import { getInserviceTopics, getInserviceWorkshops, getPersonnelData, addNewWorkshop, bulkImportInservicesFromCSV } from '../../../../apis/inserviceApi'
import { fetchPersonnels } from '../../../../apis/personnelApi';
import { debounce } from 'lodash';
import { getUserData } from "../../../../utils/utils";
import moment from 'moment';
import ExcelJS from 'exceljs';
import { parseCSV, convertCSVToPayload, downloadCSVTemplate, downloadErrorCSV, validateCSVRow, CSVError } from '../../../../utils/csvUtils';
interface InserviceWorkShopProps {
	setActiveTab: any;
	inserviceWorshopFormData: IInserviceWorkShop;
	errors: any;
	handleChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
	handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
	isEditing: boolean;
	isLoading: boolean;
}
interface Topic {
	topicID: number;
	topicName: string;
}
interface SelectOption {
	value: number;
	label: string;
}
interface TopicOption {
	label: string;
	value: number; // Adjust the type based on what your `value` is.
}

const WorkShopSecondForm: React.FC<InserviceWorkShopProps> = ({ setActiveTab, handleChange, handleSubmit, errors, inserviceWorshopFormData, isEditing, isLoading }) => {
	const [topics, setTopics] = useState<Topic[]>([]);
	const fileInputRef = React.useRef<HTMLInputElement>(null);
	const [workshops, setWorkshops] = useState([]);
	const [personnelCheck, setPersonnelCheck] = useState([]);
	const [selectedTopics, setSelectedTopics] = useState([])
	const [selectedPersonals, setSelectedPersonels] = useState([])
	const [selectedWorkshop, setSelectedWorkshop] = useState<any>(null)

	const [personnelOptions, setPersonnelOptions] = useState<any[]>([]);
	const [personnelPage, setPersonnelPage] = useState(1);
	const [hasMorePersonnel, setHasMorePersonnel] = useState(true);
	const [isLoadingPersonnel, setIsLoadingPersonnel] = useState(false);
	const [showAddWorkshopModal, setShowAddWorkshopModal] = useState(false);
	const [newWorkshopName, setNewWorkshopName] = useState('');
	const [isAddingWorkshop, setIsAddingWorkshop] = useState(false);
	const [isImportingCSV, setIsImportingCSV] = useState(false);
	const [showCSVModal, setShowCSVModal] = useState(false);
	const [showErrorModal, setShowErrorModal] = useState(false);
	const [csvErrors, setCsvErrors] = useState<CSVError[]>([]);
	const [showMatchedModal, setShowMatchedModal] = useState(false);
	const [preSelectedPersonnels, setPreSelectedPersonnels] = useState<any[]>([]);
	const [unmatchedNamesList, setUnmatchedNamesList] = useState<string[]>([]);
	const userData = getUserData();

	useEffect(() => {
		const fetchData = async () => {
			try {
				const topicsData = await getInserviceTopics();
				const workshopsData = await getInserviceWorkshops();
				if (topicsData.success) {
					setTopics(topicsData.data);
				}
				if (workshopsData.success) {
					setWorkshops(workshopsData.data);
				}
				loadMorePersonnel();
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		};

		fetchData();
	}, []);

	// Set selected workshop when form data changes (for editing)
	useEffect(() => {
		if (inserviceWorshopFormData.workshopTypeId && workshops.length > 0) {
			const workshop: any = workshops.find((w: any) => w.workshopTypeID === inserviceWorshopFormData.workshopTypeId);
			if (workshop) {
				setSelectedWorkshop({
					value: workshop.workshopTypeID,
					label: workshop.workshopTypeName
				});
			}
		} else {
			setSelectedWorkshop(null);
		}
	}, [inserviceWorshopFormData.workshopTypeId, workshops]);
	const loadMorePersonnel = async (searchQuery: string = "") => {
		try {
			const personnelData = await fetchPersonnels(searchQuery, personnelPage, 100);
			if (personnelData && personnelData.data) {
				const newOptions = personnelData.data.map((person: any) => ({
					value: person.personalID,
					label: `${person.firstname} ${person.lastname}`
				}));

				setPersonnelOptions((prevOptions: any) => [...prevOptions, ...newOptions]);
				setPersonnelPage(prevPage => prevPage + 1);
				setHasMorePersonnel(personnelData.data.length === 100);
			}
		} catch (error) {
			console.error("Error fetching personnel data:", error);
		} finally {
			// setIsLoadingPersonnel(false);
		}
	};

	const debouncedLoadMore = useCallback(
		debounce((inputValue: string) => {
			setPersonnelOptions([]);
			setPersonnelPage(1);
			setHasMorePersonnel(true);
			loadMorePersonnel(inputValue);
		}, 300),
		[]
	);


	const sortOptions = (options: any[]) => {
		if (!options) return [];
		return [...options].sort((a, b) => (a.label || '').localeCompare(b.label || '', undefined, { numeric: true }));
	};

	const mapTopicsToOptions = (topics: any) => {
		return topics.map((topic: any) => ({
			value: topic.topicID,
			label: topic.topicName,
		}));
	};

	const mapWorkshopsToOptions = (workshops: any) => {
		return workshops.map((workshop: any) => ({
			value: workshop.workshopTypeID,
			label: workshop.workshopTypeName,
		}));
	};

	const topicOptions = sortOptions(mapTopicsToOptions(topics));
	const workshopOptions = sortOptions(mapWorkshopsToOptions(workshops));

	const handleTopicChange = (e: any) => {
		setSelectedTopics(e);
		handleChange({ target: { name: 'topicIds', value: e.map((x: any) => x.value) } } as unknown as ChangeEvent<HTMLSelectElement>)
	}
	const handlePersonnelChange = (e: any) => {
		setSelectedPersonels(e);
		handleChange({ target: { name: 'personnelIds', value: e.map((x: any) => x.value) } } as unknown as ChangeEvent<HTMLSelectElement>)
	}
	const handleWorkshopChange = (e: any) => {
		setSelectedWorkshop(e);
		handleChange({ target: { name: 'workshopTypeId', value: e ? e.value : '' } } as unknown as ChangeEvent<HTMLSelectElement>)
	}

	const formatDate = (dateString: any) => {
		if (!dateString) return '';

		const date = new Date(dateString);
		const currentDate = moment(dateString).format('YYYY-MM-DD');
		return currentDate;
		// const year = date.getFullYear();
		// const month = String(date.getMonth() + 1).padStart(2, '0');
		// const day = String(date.getDate()).padStart(2, '0');

		// return `${year}-${month}-${day}`;
	};
	const handleHoursBlur = (e: React.FocusEvent<HTMLInputElement>) => {
		let value = e.target.value;
		if (!value) return;

		const formatted = Number(value).toFixed(2);

		handleChange({
			target: { name: "hours", value: formatted }
		} as React.ChangeEvent<HTMLInputElement>);
	};

	const handleAddWorkshop = async () => {
		if (!newWorkshopName.trim()) {
			return;
		}
		setIsAddingWorkshop(true);
		try {
			const response = await addNewWorkshop(newWorkshopName.trim());
			// Refresh workshops list
			const workshopsData = await getInserviceWorkshops();
			if (workshopsData.success) {
				setWorkshops(workshopsData.data);
				// Auto-select the newly added workshop
				const newWorkshop = workshopsData.data.find((w: any) => w.workshopTypeName === newWorkshopName.trim());
				if (newWorkshop) {
					const newOption = {
						value: newWorkshop.workshopTypeID,
						label: newWorkshop.workshopTypeName
					};
					setSelectedWorkshop(newOption);
					handleChange({ target: { name: 'workshopTypeId', value: newWorkshop.workshopTypeID } } as unknown as ChangeEvent<HTMLSelectElement>);
				}
			}
			setShowAddWorkshopModal(false);
			setNewWorkshopName('');
		} catch (error) {
			console.error("Error adding workshop:", error);
		} finally {
			setIsAddingWorkshop(false);
		}
	};

	const handleCloseModal = () => {
		setShowAddWorkshopModal(false);
		setNewWorkshopName('');
	};

	const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
		const file = event.target.files?.[0];
		if (!file) return;

		setIsImportingCSV(true);
		try {
			let rawNames: string[] = [];

			if (file.name.endsWith('.csv')) {
				const text = await file.text();
				// console.log('CSV file content:', text); // Added debug log
				rawNames = text
					.split(/\r?\n/)
					.map(line => line.trim().replace(/"/g, ''))
					.filter(name => name !== '');
			} else if (file.name.endsWith('.xlsx')) {
				const workbook = new ExcelJS.Workbook();
				const arrayBuffer = await file.arrayBuffer();
				await workbook.xlsx.load(arrayBuffer);
				
				// console.log('Workbook loaded, worksheets:', workbook.worksheets.length); // Added debug log
				
				const worksheet = workbook.getWorksheet(1);
				// console.log('Worksheet found:', !!worksheet); // Added debug log
				
				if (!worksheet) {
					// console.log('No worksheet found, trying first worksheet');
					const firstWorksheet = workbook.worksheets[0];
					if (firstWorksheet) {
						// console.log('Using first worksheet:', firstWorksheet.name);
						firstWorksheet.eachRow((row, rowNumber) => {
							if (rowNumber > 0) { // Skip header row if needed
								const cellValue = row.getCell(1).value;
								// console.log(`Row ${rowNumber}, Cell Value:`, cellValue); // Added debug log
								if (cellValue && cellValue.toString().trim()) {
									const name = cellValue.toString().trim();
									rawNames.push(name);
									// console.log('Added name:', name); // Added debug log
								}
							}
						});
					}
				} else {
					worksheet.eachRow((row, rowNumber) => {
						if (rowNumber > 0) { // Skip header row if needed
							const cellValue = row.getCell(1).value;
							// console.log(`Row ${rowNumber}, Cell Value:`, cellValue); // Added debug log
							if (cellValue && cellValue.toString().trim()) {
								const name = cellValue.toString().trim();
								rawNames.push(name);
								// console.log('Added name:', name); // Added debug log
							}
						}
					});
				}
			}

			// console.log('Raw names after parsing:', rawNames); // Added debug log

			if (rawNames.length === 0) {
				// alert('No names found in the file. Please ensure your file has names in the first column.');
				setIsImportingCSV(false);
				return;
			}

			// console.log('Processing names:', rawNames); // Debug log

			// Fetch all personnel to match names
			// console.log('Fetching personnel data...');
			const allPersonnelData = await fetchPersonnels("", 1, 10000);
			const allPersonnel = allPersonnelData?.data || [];

			// console.log('Found personnel:', allPersonnel.length); // Debug log

			if (!allPersonnelData || allPersonnel.length === 0) {
				// alert('Unable to fetch personnel data from the server. Please try again.');
				setIsImportingCSV(false);
				return;
			}

			const matchedSet: any[] = [];
			const unmatched: string[] = [];
			const seenIds = new Set();

			rawNames.forEach(rawName => {
				const searchName = rawName.toLowerCase().trim();
				if (!searchName) return;

				let found = null;

				// Matching logic: supports "Lastname, Firstname", "Firstname Lastname", single names, etc.
				found = allPersonnel.find((p: any) => {
					const fname = (p.firstname || '').toLowerCase().trim();
					const lname = (p.lastname || '').toLowerCase().trim();

					const fullName = `${fname} ${lname}`;
					const reverseNameComma = `${lname}, ${fname}`;
					const reverseNameNoComma = `${lname} ${fname}`;

					return fullName === searchName ||
						reverseNameComma === searchName ||
						reverseNameNoComma === searchName ||
						fname === searchName ||
						lname === searchName;
				});

				if (found) {
					if (!seenIds.has(found.personalID)) {
						matchedSet.push({
							value: found.personalID,
							label: `${found.firstname} ${found.lastname}`,
							selected: true
						});
						seenIds.add(found.personalID);
					}
				} else {
					unmatched.push(rawName);
				}
			});

			// console.log('Matched:', matchedSet.length, 'Unmatched:', unmatched.length); // Debug log

			setPreSelectedPersonnels(matchedSet);
			setUnmatchedNamesList(unmatched);
			setShowCSVModal(false);
			setShowMatchedModal(true);

			event.target.value = '';

		} catch (error) {
			console.error("Error importing file:", error);
			// alert('Error processing file. Please check the file format and try again.');
		} finally {
			setIsImportingCSV(false);
		}
	};

	const handleConfirmMatched = () => {
		const selected = preSelectedPersonnels.filter(p => p.selected);
		const ids = selected.map(p => p.value);

		setSelectedPersonels(selected as any);
		handleChange({ target: { name: 'personnelIds', value: ids } } as unknown as ChangeEvent<HTMLSelectElement>);
		setShowMatchedModal(false);
	};

	const togglePreSelected = (id: number) => {
		setPreSelectedPersonnels(prev => prev.map(p =>
			p.value === id ? { ...p, selected: !p.selected } : p
		));
	};

	const handleDownloadUnmatchedReport = () => {
		if (unmatchedNamesList.length === 0) return;

		const csvContent = "Unmatched Names\n" + unmatchedNamesList.join("\n");
		const blob = new Blob([csvContent], { type: 'text/csv' });
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = 'unmatched_personnel_report.csv';
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		window.URL.revokeObjectURL(url);
	};

	const handleDownloadTemplate = () => {
		downloadCSVTemplate();
	};

	const handleCSVModalClose = () => {
		setShowCSVModal(false);
	};

	const handleErrorModalClose = () => {
		setShowErrorModal(false);
		setCsvErrors([]);
	};

	const handleDownloadErrorCSV = () => {
		downloadErrorCSV(csvErrors, csvErrors.map(e => e.originalData));
	};

	return (
		<>
			<form method="post" className="DistrictForm" onSubmit={handleSubmit}>
				<div className="seachStrip pb-lg-4 pb-md-3 pb-3">
					<div className="row">
						<div
							className="col-12 d-flex align-items-lg-center align-items-md-center align-items-sm-center align-items-start justify-content-between gap-2 flex-lg-row flex-md-row flex-sm-row flex-column">
							{/* <h3 className="text-nowrap formTitle m-0">Inservice</h3> */}
							<div
								className="d-lg-flex d-md-flex d-sm-flex d-none align-items-center justify-content-lg-end justify-content-md-end justify-content-sm-end justify-content-start w-100 gap-lg-4 gap-md-3 gap-3 ">
								{/* <div
                                className="d-lg-flex d-md-flex d-sm-flex d-none align-items-center justify-content-lg-end justify-content-md-end justify-content-sm-end justify-content-start w-100 gap-lg-4 gap-md-3 gap-3"> */}
								<button className="btn btn-transparent" type='button' onClick={() => setActiveTab(0)}>Discard</button>
								{userData.role !== "Scope.AdminView" && userData.role !== "Scope.StudentService" && userData.role !== "Scope.PayrollService1" && userData.role !== "Scope.PayrollService2" && userData.role !== "Scope.StudentService_PayrollService1" && userData.role !== "Scope.StudentService_PayrollService1AND2" &&
									<button type="submit" className="btn btn-primary d-flex align-items-center gap-2"> {isLoading ? (
										<span className="btnloader loader"></span>
									) : (
										<span>{isEditing ? 'Edit' : 'Submit'}</span>
									)}</button>
								}


								{/* <button type="submit" className="btn btn-primary d-flex align-items-center gap-2">
                                    <span>{isEditing ? 'Edit' : 'Submit'}</span>
                                </button> */}
							</div>
						</div>
					</div>
				</div>
				<div className="paginationDiv mb-0">
					<div className="row g-4 justify-content-center">
						<div className="col-12 px-0">
							<div className="pageTable pt-0">
								<div className="pageTableInner  personalTab pb-0">
									<div className="row m-0 justify-content-center">
										<div className="col-12">
											<>
												<div className="tab-content" id="nav-tabContent">
													<div className="tab-pane fade show active" id="nav-basicinfo"
														role="tabpanel" aria-labelledby="nav-basicinfo-tab"
														tabIndex={0}>
														<div className='row g-3'>
															<div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12'>
																<div className="formCard">
																	<div
																		className="FormTitleWithdivider position-relative d-flex align-items-center gap-3  mb-lg-3 mb-md-3 mb-3">
																		<h3 className="text-nowrap formTitle m-0">Workshop
																		</h3>
																		<hr className="w-100" />
																		<div className="d-flex gap-2">
																			<button
																				type="button"
																				className="btn btn-primary"
																				onClick={() => setShowAddWorkshopModal(true)}
																				style={{ whiteSpace: 'nowrap' }}
																			>
																				Add New
																			</button>
																			<button
																				type="button"
																				className="btn btn-primary"
																				onClick={() => setShowCSVModal(true)}
																				style={{ whiteSpace: 'nowrap' }}
																			>
																				Import CSV
																			</button>
																		</div>
																	</div>
																	<div className="DistrictForm">
																		<div className="mb-0 g-2 row">

																			<div className="col-lg-6 col-md-6 col-sm-6 col-12">
																				<div className="mb-0 multiselectDrop">
																					<label className="form-label mb-1">Workshops:</label>
																					<Select
																						name="workshopTypeId"
																						options={workshopOptions}
																						value={selectedWorkshop}
																						onChange={handleWorkshopChange}
																						menuPlacement="auto"
																						menuPosition="fixed"
																						menuPortalTarget={document.body}
																						styles={{
																							menuPortal: base => ({ ...base, zIndex: 9999 }),
																						}}
																						placeholder="Select Workshops"
																						isClearable
																					/>
																					{errors?.workshopTypeId && (
																						<div className="text-danger">
																							{errors?.workshopTypeId?._errors[0]}
																						</div>
																					)}
																				</div>
																			</div>
																			{/* <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                                                                                <div className="mb-0">
                                                                                    <label className="form-label mb-1">InService Training</label>
                                                                                    <input type="text" className="form-control" id='training' name='training'
                                                                                        value={inserviceWorshopFormData.training}
                                                                                        onChange={(e) => { handleChange(e) }}
                                                                                        onBlur={(e) => { }}
                                                                                    />
                                                                                    {errors?.training && (
                                                                                        <div className="text-danger">
                                                                                            {errors?.training?._errors[0]}
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div> */}
																			<div className="col-lg-6 col-md-6 col-sm-6 col-12">
																				<div className="mb-0">
																					<label className="form-label mb-1">Sponsor</label>
																					<input type="text" className="form-control" id='sponsor' name='sponsor'
																						value={inserviceWorshopFormData.sponsor}
																						onChange={(e) => { handleChange(e) }}
																						onBlur={(e) => { }}
																					/>
																					{errors?.sponsor && (
																						<div className="text-danger">
																							{errors?.sponsor?._errors[0]}
																						</div>
																					)}
																				</div>
																			</div>

																			<div className="col-lg-6 col-md-6 col-sm-6 col-12">
																				<div className="mb-0 multiselectDrop">
																					<label className="form-label mb-1">Topics:</label>
																					<Select isMulti name="topicIds"
																						menuPlacement="top"
																						menuPosition="fixed"
																						menuPortalTarget={document.body}
																						styles={{
																							menuPortal: base => ({ ...base, zIndex: 9999 }),
																						}}
																						isClearable
																						options={topicOptions} value={selectedTopics} onChange={handleTopicChange} />
																					{errors?.topicId && (
																						<div className="text-danger">
																							{errors?.topicId?._errors[0]}
																						</div>
																					)}
																				</div>
																			</div>

																			<div className="col-lg-6 col-md-6 col-sm-6 col-12">
																				<div className="mb-0 multiselectDrop">
																					<label className="form-label mb-1">Personnel:</label>
																					<Select isMulti name="personnelIds" isClearable
																						options={sortOptions(personnelOptions)}
																						value={selectedPersonals}
																						menuPlacement="top"
																						menuPosition="fixed"
																						menuPortalTarget={document.body}
																						styles={{
																							menuPortal: base => ({ ...base, zIndex: 9999 }),
																						}}
																						onChange={handlePersonnelChange} onMenuScrollToBottom={() => {
																							if (hasMorePersonnel) {
																								loadMorePersonnel();
																							}
																						}}
																						onInputChange={(inputValue) => {
																							debouncedLoadMore(inputValue);
																						}}
																						isLoading={isLoadingPersonnel}
																					/>
																					{errors?.personnelIds && (
																						<div className="text-danger">
																							{errors?.personnelIds?._errors[0]}
																						</div>
																					)}
																				</div>
																			</div>
																			<div className="col-lg-6 col-md-6 col-sm-6 col-12">
																				<div className="mb-0">
																					<label className="form-label mb-1">Hours:</label>
																					<input type="text" className="form-control" id='hours' name='hours' value={inserviceWorshopFormData.hours!} //
																						// onChange={(e) => { handleChange(e) }}
																						// onBlur={(e) => { }}
																						onChange={handleChange}
																						onBlur={handleHoursBlur}
																					/>
																					{errors?.hours && (
																						<div className="text-danger">
																							{errors?.hours?._errors[0]}
																						</div>
																					)}
																				</div>
																			</div>
																			<div className="col-lg-6 col-md-6 col-sm-6 col-12">
																				<div className="mb-0">
																					<label className="form-label mb-1">Date:</label>
																					<input type="date" className="form-control" id='date' name='date'
																						value={formatDate(inserviceWorshopFormData.date)} onChange={(e) => { handleChange(e) }}
																						onBlur={(e) => { }}
																					/>
																					{errors?.date && (
																						<div className="text-danger">
																							{errors?.date?._errors[0]}
																						</div>
																					)}
																				</div>
																			</div>
																			<div className="col-lg-6 col-md-6 col-sm-6 col-12">
																				<div className="mb-0">
																					<label className="form-label mb-1">Paid Date</label>
																					<input type="date" className="form-control" id='paidDate' name='paidDate'
																						value={formatDate(inserviceWorshopFormData.paidDate)}
																						onChange={(e) => { handleChange(e) }}
																						onBlur={(e) => { }}

																					/>
																					{errors?.paidDate && (
																						<div className="text-danger">
																							{errors?.paidDate?._errors[0]}
																						</div>
																					)}
																				</div>
																			</div>



																			{/* <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                                                                                <div className="mb-0">
                                                                                    <label className="form-label mb-1">Sexual Harassment II:</label>
                                                                                    <input type="date" className="form-control" id='sHarassmentExp2' name='sHarassmentExp2'
                                                                                        value={formatDate(inserviceWorshopFormData.sHarassmentExp2)}
                                                                                        onChange={(e) => { handleChange(e) }}
                                                                                        onBlur={(e) => { }}
                                                                                    />
                                                                                    {errors?.sHarassmentExp2 && (
                                                                                        <div className="text-danger">
                                                                                            {errors?.sHarassmentExp2?._errors[0]}
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div> */}


																		</div>

																	</div >
																</div>
															</div>
															<div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12'>
																<div className="formCard h-100">
																	<div
																		className="FormTitleWithdivider position-relative d-flex align-items-center gap-3  mb-lg-3 mb-md-3 mb-3">
																		<h3 className="text-nowrap formTitle m-0">Inservice
																		</h3>
																		<hr className="w-100" />
																	</div>
																	<div className="DistrictForm">
																		<div className="mb-0 g-2 row">
																			<div className="col-lg-6 col-md-6 col-sm-6 col-12">
																				<div className="mb-0">
																					<label className="form-label mb-1">E. Laws:</label>
																					<input type="date" className="form-control" id='elaw' name='elaw'
																						value={formatDate(inserviceWorshopFormData.elaw)}
																						onChange={(e) => { handleChange(e) }}
																						onBlur={(e) => { }}
																					/>
																					{errors?.elaw && (
																						<div className="text-danger">
																							{errors?.elaw?._errors[0]}
																						</div>
																					)}
																				</div>
																			</div>
																			{/* Date */}
																			{/* Hours */}
																			<div className="col-lg-6 col-md-6 col-sm-6 col-12">
																				<div className="mb-0">
																					<label className="form-label mb-1">Foundations 5hr:</label>
																					<input type="date" className="form-control" id='foundations' name='foundations'
																						value={formatDate(inserviceWorshopFormData.foundations)}
																						onChange={(e) => { handleChange(e) }}
																						onBlur={(e) => { }}
																					/>
																					{errors?.foundations && (
																						<div className="text-danger">
																							{errors?.foundations?._errors[0]}
																						</div>
																					)}
																				</div>
																			</div>


																			{/* Paid */}
																			<div className="col-lg-6 col-md-6 col-sm-6 col-12">
																				<div className="mb-0">
																					<label className="form-label mb-1">Foundations 15hr:</label>
																					<input type="date" className="form-control" id='foundations15H' name='foundations15H'
																						value={formatDate(inserviceWorshopFormData.foundations15H)}
																						onChange={(e) => { handleChange(e) }}
																						onBlur={(e) => { }}
																					/>
																					{errors?.foundations15H && (
																						<div className="text-danger">
																							{errors?.foundations15H?._errors[0]}
																						</div>
																					)}
																				</div>
																			</div>

																			<div className="col-lg-6 col-md-6 col-sm-6 col-12">
																				<div className="mb-0">
																					<label className="form-label mb-1">CPR Expires :</label>
																					<input type="date" className="form-control" id='cpr' name='cpr' value={formatDate(inserviceWorshopFormData.cpr)}
																						onChange={(e) => { handleChange(e) }}
																					/>
																					{errors?.cpr && (
																						<div className="text-danger">
																							{errors?.cpr?._errors[0]}
																						</div>
																					)}
																				</div>
																			</div>
																			<div className="col-lg-6 col-md-6 col-sm-6 col-12">
																				<div className="mb-0">
																					<label className="form-label mb-1">Mat Expires :</label>
																					<input type="date" className="form-control" id='matDate' name='matDate'
																						value={formatDate(inserviceWorshopFormData.matDate)} onChange={(e) => { handleChange(e) }}
																					/>
																					{errors?.matDate && (
																						<div className="text-danger">
																							{errors?.matDate?._errors[0]}
																						</div>
																					)}

																				</div>
																			</div>
																			<div className="col-lg-6 col-md-6 col-sm-6 col-12">
																				<div className="mb-0">
																					<label className="form-label mb-1">First Aid Expires :</label>
																					<input type="date" className="form-control" id='firstAid' name='firstAid'
																						value={formatDate(inserviceWorshopFormData.firstAid)} onChange={(e) => { handleChange(e) }}
																					/>
																					{errors?.firstAid && (
																						<div className="text-danger">
																							{errors?.firstAid?._errors[0]}
																						</div>
																					)}
																				</div>
																			</div>
																			<div className="col-lg-6 col-md-6 col-sm-6 col-12">
																				<div className="mb-0">
																					<label className="form-label mb-1">Child Abuse "Expires" :</label>
																					<input type="date" className="form-control" id='matApp' name='matApp'
																						value={formatDate(inserviceWorshopFormData.matApp)} onChange={(e) => { handleChange(e) }}
																						onBlur={(e) => { }}
																					/>
																					{errors?.matApp && (
																						<div className="text-danger">
																							{errors?.matApp?._errors[0]}
																						</div>
																					)}
																				</div>
																			</div>
																			<div className="col-lg-6 col-md-6 col-sm-6 col-12">
																				<div className="mb-0">
																					<label className="form-label mb-1">Sexual Harassment I :</label>
																					<input type="date" className="form-control" id='sHarassmentExp' name='sHarassmentExp'
																						value={formatDate(inserviceWorshopFormData.sHarassmentExp)} onChange={(e) => { handleChange(e) }}
																						onBlur={(e) => { }}
																					/>
																					{errors?.sHarassmentExp && (
																						<div className="text-danger">
																							{errors?.sHarassmentExp?._errors[0]}
																						</div>
																					)}
																				</div>
																			</div>
																			<div className="col-lg-6 col-md-6 col-sm-6 col-12">
																				<div className="mb-0">
																					<label className="form-label mb-1">ACES:</label>
																					<input type="date" className="form-control" id='aces' name='aces'
																						value={formatDate(inserviceWorshopFormData.aces)} onChange={(e) => { handleChange(e) }}
																						onBlur={(e) => { }}
																					/>
																					{errors?.aces && (
																						<div className="text-danger">
																							{errors?.aces?._errors[0]}
																						</div>
																					)}
																				</div>
																			</div>
																			<div className="col-lg-12 col-md-12 col-sm-12 col-12">

																				<div className="mb-0">
																					<div className="d-flex align-items-center gap-4">
																						<div className="d-flex checked align-items-center gap-2">
																							<div className="inputDesign position-relative">
																								<input type="checkbox" id="paid" name="paid" checked={inserviceWorshopFormData.paid}
																									onChange={handleChange} />
																								{errors?.paid && (
																									<div className="text-danger">
																										{errors?.paid?._errors[0]}
																									</div>
																								)}
																								<div className="checked">
																									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
																										<path
																											d="M14.9999 10.5L10.5253 14.4999L8.99997 13.1365M19.9999 7.49998L19.9999 17.5C19.9999 19.1569 18.6568 20.5 16.9999 20.5H6.99998C5.34314 20.5 4 19.1569 4 17.5V7.49998C4 5.84314 5.34314 4.5 6.99998 4.5H16.9999C18.6568 4.5 19.9999 5.84314 19.9999 7.49998Z"
																											stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
																									</svg>
																								</div>
																								<div className="Unchecked">
																									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
																										<path
																											d="M17 4.5C18.6569 4.5 20 5.84314 20 7.49998V17.5C20 19.1569 18.6569 20.5 17 20.5H7C5.34315 20.5 4 19.1569 4 17.5L4 7.49998C4 5.84314 5.34315 4.5 7 4.5L17 4.5Z"
																											stroke="#A4A4A4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
																									</svg>
																								</div>
																							</div>
																							<label className="form-label m-0" style={{
																								fontWeight: inserviceWorshopFormData.paid ? 'bold' : 'normal'
																							}}>Paid</label>
																						</div>
																					</div>
																				</div>
																			</div>
																			{/* Tpics */}
																			{/* Personel */}


																		</div>

																	</div >
																</div>
															</div>
														</div>
													</div>
												</div>
											</>
										</div>
									</div>
								</div>
							</div>


							{/* <div
                                    className="d-lg-none d-md-none d-sm-none d-flex mt-lg-0 mt-md-0 mt-sm-0 mt-4 align-items-center justify-content-lg-end justify-content-md-end justify-content-sm-end justify-content-start w-100 gap-lg-4 gap-md-3 gap-3">

                                    {isEditing && (
                                        <>
                                            <button className="btn btn-outline" onClick={handlePrevStep}>Cancel</button>
                                        </>
                                    )}
                                    {!isEditing && (
                                        <>
                                            <button className="btn btn-transparent" onClick={handlePrevStep}>Discard</button>
                                        </>
                                    )}

                                    <button className="btn btn-primary" onClick={handleSubmit}> {loading ? (
                                        <span className="btnloader loader"></span>
                                    ) : (
                                        <span>{isEditing ? 'Edit' : 'Submit'}</span>
                                    )}</button>
                                </div> */}
						</div>
					</div>
				</div>
			</form >
			{/* Add Workshop Modal */}
			{showAddWorkshopModal && (
				<div className={`modal fade show align-items-lg-center overflow-auto align-items-md-center align-items-start justify-content-center`}
					style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1050 }}
					id="AddWorkshopModal" aria-labelledby="AddWorkshopModalLabel" aria-hidden="true"
					onClick={(e) => {
						if (e.target === e.currentTarget) {
							handleCloseModal();
						}
					}}>
					<div className="modal-dialog">
						<div className="modal-content p-4" onClick={(e) => e.stopPropagation()}>
							<div className="modal-body p-lg-2 p-md-2 p-0">
								<div className="formCard mt-0 p-0 border-0">
									<div className="FormTitleWithdivider position-relative d-flex align-items-center gap-3 mb-lg-3 mb-md-3 mb-3">
										<h3 className="text-nowrap formTitle m-0">Add New Workshop</h3>
										<hr className="w-100" />
										<div className="editForm" onClick={handleCloseModal} style={{ cursor: 'pointer' }}>
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
												<path d="M19 5.5L5 19.5M19 19.5L5 5.5" stroke="black" strokeWidth="2" strokeLinecap="round"></path>
											</svg>
										</div>
									</div>
									<form className="DistrictForm" onSubmit={(e) => { e.preventDefault(); handleAddWorkshop(); }}>
										<div className="mb-3 row">
											<div className="col-lg-12 col-md-12 col-sm-12 col-12">
												<div className="mb-2">
													<label className="form-label mb-1">Workshop Name:</label>
													<input
														type="text"
														className="form-control"
														id="workshopTypeName"
														name="workshopTypeName"
														value={newWorkshopName}
														onChange={(e) => setNewWorkshopName(e.target.value)}
														placeholder="Enter workshop name"
														autoFocus
													/>
												</div>
											</div>
										</div>
										<div className="d-flex align-items-center justify-content-end gap-lg-4 gap-md-3 gap-3">
											<button type="button" onClick={handleCloseModal} className="btn btn-transparent ps-3 pe-4">
												Cancel
											</button>
											{userData.role !== "Scope.AdminView" && userData.role !== "Scope.StudentService" && userData.role !== "Scope.PayrollService1" && userData.role !== "Scope.PayrollService2" && userData.role !== "Scope.StudentService_PayrollService1" && userData.role !== "Scope.StudentService_PayrollService1AND2" &&
												<button type="submit" className="btn btn-primary ps-3 pe-4" disabled={isAddingWorkshop || !newWorkshopName.trim()}>
													{isAddingWorkshop ? (
														<span className="btnloader loader"></span>
													) : (
														'Save'
													)}
												</button>
											}
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
			{/* CSV Import Modal */}
			{showCSVModal && (
				<div className={`modal fade show align-items-lg-center overflow-auto align-items-md-center align-items-start justify-content-center`}
					style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1050 }}
					id="CSVImportModal" aria-labelledby="CSVImportModalLabel" aria-hidden="true"
					onClick={(e) => {
						if (e.target === e.currentTarget) {
							handleCSVModalClose();
						}
					}}>
					<div className="modal-dialog">
						<div className="modal-content p-4" onClick={(e) => e.stopPropagation()}>
							<div className="modal-body p-lg-2 p-md-2 p-0">
								<div className="formCard mt-0 p-0 border-0">
									<div className="FormTitleWithdivider position-relative d-flex align-items-center gap-3 mb-lg-3 mb-md-3 mb-3">
										<h3 className="text-nowrap formTitle m-0">Import CSV</h3>
										<hr className="w-100" />
										<div className="editForm" onClick={handleErrorModalClose} style={{ cursor: 'pointer' }}>
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
												<path d="M19 5.5L5 19.5M19 19.5L5 5.5" stroke="black" strokeWidth="2" strokeLinecap="round"></path>
											</svg>
										</div>
									</div>
									<div className="DistrictForm">
										<div className="mb-3">
											<p className="mb-3">
												<strong>Instructions:</strong><br />
												1. Upload a CSV or Excel (.xlsx) file with names in the first column.<br />
												2. Support for <strong>Lastname, Firstname</strong> or <strong>Firstname Lastname</strong> formats.<br />
												3. No header row is required.<br />
												4. Matching personnel will be listed for confirmation after upload.<br />
												5. An error report will be available for any names not found in the system.
											</p>

										</div>
										<div className="mb-3">
											{/* <label className="form-label mb-2">Select File:</label> */}
											<input
												type="file"
												className="form-control"
												ref={fileInputRef}
												accept=".csv,.xlsx,.xls"
												onChange={handleFileUpload}
												disabled={isImportingCSV}
												style={{ padding: '0.4rem 0.75rem', display: 'none' }}
											/>
										</div>
										<div className="d-flex align-items-center justify-content-end gap-lg-4 gap-md-3 gap-3">
											<button type="button" onClick={handleCSVModalClose} className="btn btn-transparent ps-3 pe-4">
												Cancel
											</button>
											<button
												type="button"
												className="btn btn-primary ps-3 pe-4"
												onClick={() => fileInputRef.current?.click()}
												disabled={isImportingCSV}
											>
												{isImportingCSV ? (
													<>
														<span className="btnloader loader"></span>
														Importing...
													</>
												) : (
													'Select & Import'
												)}
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
			{/* CSV Error Modal */}
			{showErrorModal && (
				<div className={`modal fade show align-items-lg-center overflow-auto align-items-md-center align-items-start justify-content-center`}
					style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1050 }}
					id="CSVErrorModal" aria-labelledby="CSVErrorModalLabel" aria-hidden="true"
					onClick={(e) => {
						if (e.target === e.currentTarget) {
							handleErrorModalClose();
						}
					}}>
					<div className="modal-dialog">
						<div className="modal-content p-4" onClick={(e) => e.stopPropagation()}>
							<div className="modal-body p-lg-2 p-md-2 p-0">
								<div className="formCard mt-0 p-0 border-0">
									<div className="FormTitleWithdivider position-relative d-flex align-items-center gap-3 mb-lg-3 mb-md-3 mb-3">
										<h3 className="text-nowrap formTitle m-0">CSV Import Errors</h3>
										<hr className="w-100" />
										<div className="editForm" onClick={handleErrorModalClose} style={{ cursor: 'pointer' }}>
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
												<path d="M19 5.5L5 19.5M19 19.5L5 5.5" stroke="black" strokeWidth="2" strokeLinecap="round"></path>
											</svg>
										</div>
									</div>
									<div className="DistrictForm">
										<div className="mb-3">
											<p className="mb-3">
												<strong>CSV validation failed!</strong><br />
												Found {csvErrors.length} error(s) in the CSV file.<br />
												Please download the error report below to see details and fix the issues.
											</p>
											<div className="d-flex gap-2 mb-3">
												<button
													type="button"
													className="btn btn-danger"
													onClick={handleDownloadErrorCSV}
												>
													Download Error Report
												</button>
												<button
													type="button"
													className="btn btn-outline-secondary"
													onClick={handleErrorModalClose}
												>
													Close
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
			{/* Matched Personnel Confirmation Modal */}
			{showMatchedModal && (
				<div className={`modal fade show align-items-lg-center overflow-auto align-items-md-center align-items-start justify-content-center`}
					style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1060 }}
					id="MatchedModal" aria-labelledby="MatchedModalLabel" aria-hidden="true"
					onClick={(e) => {
						if (e.target === e.currentTarget) {
							setShowMatchedModal(false);
						}
					}}>
					<div className="modal-dialog modal-lg">
						<div className="modal-content p-4" onClick={(e) => e.stopPropagation()}>
							<div className="modal-body p-lg-2 p-md-2 p-0">
								<div className="formCard mt-0 p-0 border-0">
									<div className="FormTitleWithdivider position-relative d-flex align-items-center gap-3 mb-lg-3 mb-md-3 mb-3">
										<h3 className="text-nowrap formTitle m-0">Import Summary</h3>
										<hr className="w-100" />
										<div className="editForm" onClick={() => setShowMatchedModal(false)} style={{ cursor: 'pointer' }}>
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
												<path d="M19 5.5L5 19.5M19 19.5L5 5.5" stroke="black" strokeWidth="2" strokeLinecap="round"></path>
											</svg>
										</div>
									</div>
									<div className="DistrictForm">
										<div className="row mb-3">
											<div className="col-12">
												<div className="alert alert-info d-flex justify-content-between align-items-center">
													<div>
														Found <strong>{preSelectedPersonnels.length}</strong> matches.
														{unmatchedNamesList.length > 0 && <span className="ms-2">There were <strong>{unmatchedNamesList.length}</strong> unmatched names.</span>}
													</div>
													{unmatchedNamesList.length > 0 && (
														<button className="btn btn-sm btn-danger" onClick={handleDownloadUnmatchedReport}>
															Download Error Report
														</button>
													)}
												</div>
											</div>
										</div>

										{preSelectedPersonnels.length > 0 ? (
											<>
												<p className="mb-2">Select personnel to add to the workshop:</p>
												<div style={{ maxHeight: '400px', overflowY: 'auto', border: '1px solid #eee', padding: '10px', borderRadius: '5px' }}>
													<div className="row">
														{preSelectedPersonnels.map((p) => (
															<div key={p.value} className="col-md-6 mb-2">
																<div className="d-flex align-items-center gap-2">
																	<div className="inputDesign position-relative">
																		<input
																			type="checkbox"
																			checked={p.selected}
																			onChange={() => togglePreSelected(p.value)}
																		/>
																		<div className="checked">
																			<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 24 25" fill="none">
																				<path d="M14.9999 10.5L10.5253 14.4999L8.99997 13.1365M19.9999 7.49998L19.9999 17.5C19.9999 19.1569 18.6568 20.5 16.9999 20.5H6.99998C5.34314 20.5 4 19.1569 4 17.5V7.49998C4 5.84314 5.34314 4.5 6.99998 4.5H16.9999C18.6568 4.5 19.9999 5.84314 19.9999 7.49998Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																			</svg>
																		</div>
																		<div className="Unchecked">
																			<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 24 25" fill="none">
																				<path d="M17 4.5C18.6569 4.5 20 5.84314 20 7.49998V17.5C20 19.1569 18.6569 20.5 17 20.5H7C5.34315 20.5 4 19.1569 4 17.5L4 7.49998C4 5.84314 5.34315 4.5 7 4.5L17 4.5Z" stroke="#A4A4A4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																			</svg>
																		</div>
																	</div>
																	<label className="m-0" style={{ cursor: 'pointer' }} onClick={() => togglePreSelected(p.value)}>
																		{p.label}
																	</label>
																</div>
															</div>
														))}
													</div>
												</div>
											</>
										) : (
											<div className="text-center py-4">
												<p className="text-muted">No personnel matches found in the system for the provided names.</p>
											</div>
										)}

										<div className="d-flex align-items-center justify-content-end gap-lg-4 gap-md-3 gap-3 mt-4">
											<button type="button" onClick={() => setShowMatchedModal(false)} className="btn btn-transparent ps-3 pe-4">
												Cancel
											</button>
											<button
												type="button"
												className="btn btn-primary ps-3 pe-4"
												onClick={handleConfirmMatched}
												disabled={preSelectedPersonnels.filter(p => p.selected).length === 0}
											>
												Confirm & Add
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	)
}

export default WorkShopSecondForm